
export const hideHeaderAction = (hide: boolean) => {
  return {
    type: 'HIDE_HEADER',
    data: { hide },
  };
};
